import React, { Component } from "react";
import { Navigate } from 'react-router-dom';
import { connect } from 'react-redux';
import { importDonorAction } from 'actions/donorActions';
import HomeNav from "components/Navbars/HomeNav.js";
import HomePageHeader from "components/Headers/HomePageHeader.js";
import DefaultFooter from "components/Footers/DefaultFooter.js";
import {Modal} from "react-bootstrap";
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';

// reactstrap components
import {
  Card,
  CardHeader,
  Container,
  Row,
  CardTitle,
  CardBody,
  InputGroup,
  Button,
  UncontrolledCollapse
} from "reactstrap";

class UploadFile extends Component {
  constructor(props) {
    super(props);
    this.state = {
      firstFocus: false,
      lastFocus: false,
      show: false,
      modalOKEnabled: false,
      selectedFile: undefined,
      errorMessage: ''
    }
    this.setShow = this.setShow.bind(this);
    this.handleShow = this.handleShow.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.handleFileChange = this.handleFileChange.bind(this);
    this.handleFileImport = this.handleFileImport.bind(this);
  }

  componentWillMount() {
    document.title = 'Import Donors';
    if (!this.props.response.login.isSignedIn) {
      //user not logged in..redirect to login page
      this.props.response.login.redirectAfterSignInTo = '/liquidlove/import/donors';
    }
  }

  componentWillUnmount() {
    if(this.props.response && 
      this.props.response.donor &&
        this.props.response.donor.importDonors)
      delete this.props.response.donor.importDonors;
  }

  setShow(bool) {
    this.setState({ show: bool });
  }
  handleClose = () => { 
    this.setShow(false); 
    //this.props.navigate('/liquidlove/requests');
  };
  
  handleShow = () => { this.setShow(true) };

  handleFileChange = event => {    
    this.setState({ errorMessage: '' });
    this.setState({ selectedFile: event.target.files[0] });

    if(!(this.props.response.login.isSuperAdmin || 
      this.props.response.login.isStateAdmin)){
      this.setState({ errorMessage: 'Sairam! You dont have privileges to import donors' });
      return false;
    }

    if(this.props.response && 
      this.props.response.donor &&
        this.props.response.donor.importDonors)
      delete this.props.response.donor.importDonors;

    if (event.target.files[0] === undefined) {
      this.setState({ errorMessage: 'Please select a file.' });
      return false;
    }
   
    if (!event.target.files[0].name.match(/\.(csv)$/)) {
      this.setState({ errorMessage: 'Only csv format is accepted.' });
      return false;
    }

    if (event.target.files[0].size > 1024000) {
      this.setState({ errorMessage: 'File size must be less than 1mb.' });
      return false;
    }
  }

  handleFileImport = event => {
    this.setState({ errorMessage: '' });
    
    if(!(this.props.response.login.isSuperAdmin || 
      this.props.response.login.isStateAdmin)){
      this.setState({ errorMessage: 'Sairam! You dont have privileges to import donors' });
      return false;
    }

    if(this.props.response && 
      this.props.response.donor &&
        this.props.response.donor.importDonors)
      delete this.props.response.donor.importDonors;

    if(this.state.selectedFile === undefined){
      this.setState({ errorMessage: 'Sairam! Please select a file. If you are retrying import, please rename the file and try again.' });
      return false;
    }

    if (!this.state.selectedFile.name.match(/\.(csv)$/)) {
      this.setState({ errorMessage: 'Only csv format is accepted.' });
      return false;
    }

    if (this.state.selectedFile.size > 1024000) {
      this.setState({ errorMessage: 'File size must be less than 1mb.' });
      return false;
    }

    let file = this.state.selectedFile;            
    let token = this.props.response.login.userToken;

    const payload = {
      token, file
    }
    this.handleShow();
    this.props.dispatch(importDonorAction(payload));
    this.state.selectedFile = undefined;
    this.setState({ errorMessage: '' });
  }  
  
  render() {
    if (!this.props.response.login.isSignedIn) {
      return <Navigate to={'/liquidlove/login'} />
    }

    let message;

    if (this.props.response.donor && this.props.response.donor.noServiceResponse === true){
      this.state.modalOKEnabled = true;
      message = 'Sairam! Not able to process your file';
    }    
    else if (this.props.response.donor.hasOwnProperty('importDonors')){
      if(this.props.response.donor.importDonors.hasOwnProperty('error')){
        this.state.modalOKEnabled = true;
        message = 'Sairam! Not able to process your file';
      }
      else{
        this.state.modalOKEnabled = true;
        message = 'Sairam! Your file is processed';
      }
    }
        
    return (      
          <div className="wrapper">
            <HomePageHeader /><HomeNav adminName={this.props.response.login.adminName}/>
            <div  className="section section-signup"
              style={{
                backgroundImage: "url(" + require("assets/img/shivaratri-wallpapers-6.png") + ")",
                backgroundSize: "cover",
                backgroundPosition: "top center",
                minHeight: "700px",
              }}
            >
              <Container>
                <Row>
                  <Card className="card-signup" data-background-color="blue">
                    <CardHeader className="text-center">
                        <CardTitle className="title-up" tag="h3">
                            Import Donors
                        </CardTitle>                  
                    </CardHeader>
                    <CardBody>                      
                      <form>
                        <Modal
                          centered
                          show={this.state.show}
                          onHide={this.handleClose}
                          backdrop="static"
                          keyboard={false}
                          >
                            <Modal.Body>
                              {message ? message : ' Sairam! Processing your request.'}
                            </Modal.Body>
                            <Modal.Footer>
                              <Button disabled={!this.state.modalOKEnabled} className="btn btn-primary mr-2" variant="primary" onClick={this.handleClose}>
                                OK
                              </Button>
                            </Modal.Footer>
                        </Modal>
                  <InputGroup
                    className={
                      "no-border" + (this.state.firstFocus ? " input-group-focus" : "")
                    }
                  >
                    <input onChange={this.handleFileChange} name="importFile" type="file" className={'form-control'} />                    
                  </InputGroup>
                  <div style={{color: "red"}}>{this.state.errorMessage}</div>
                  <br/>

                  <div style={{color: "white"}}>File Type:</div>
                  <div style={{color: "white"}}>
                    {this.state.selectedFile ? this.state.selectedFile.type : ''}</div>
                  <br/>
                  <div style={{color: "white"}}>File Size (bytes):</div>
                  <div style={{color: "white"}}>
                    {this.state.selectedFile ? this.state.selectedFile.size : ''}
                  </div>
                  <div className="col text-center">
                  <button                      
                    onClick={this.handleFileImport}  type="button" size="sm" outline className="btn btn-primary">Import</button>
                  </div>
                      </form>
                    </CardBody>                             
                </Card>
              </Row>
            </Container>                
            <br/>
          <Container>
              <Card>
                <CardBody align="center" tag="h6">Import Details</CardBody>
              </Card>
              <div style={{color: "white"}}>Total rows&nbsp;: &nbsp;
                {this.props.response.donor.importDonors ? this.props.response.donor.importDonors.totalRecords : ''}
              </div>
              <div style={{color: "white"}}>Rows imported&nbsp;:  &nbsp;
                {this.props.response.donor.importDonors ? this.props.response.donor.importDonors.numRecordsSaved : ''}
              </div>
              <div style={{color: "white"}}>Rows with errors&nbsp;:  &nbsp;
                {this.props.response.donor.importDonors ? this.props.response.donor.importDonors.numRecordsError : ''}
              </div>
              <div style={{color: "white"}}>Error details (If any)
                <button id="toggler" className="btn btn-primary btn-icon btn-round">
                  <i className="now-ui-icons arrows-1_minimal-down"></i>
                </button></div>
                <UncontrolledCollapse toggler="#toggler">
                  <div>                  
                    <TableContainer component={Paper}>
                      <Table size="small" aria-label="a dense table">
                        <TableHead>
                          <TableRow>
                          <TableCell align="left">Row number</TableCell>
                            <TableCell align="left">Error</TableCell>
                            <TableCell align="left">Field name</TableCell>
                            <TableCell align="left">Field Value</TableCell>                             
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {this.props.response.donor.importDonors && 
                            this.props.response.donor.importDonors.rowErrors ? 
                              this.props.response.donor.importDonors.rowErrors.map((row) => (
                            row.errors.map((error) => (
                              <TableRow key={row.rowNumber}>
                                <TableCell align="left">{row.rowNumber}</TableCell>
                                <TableCell align="left">{error.message}</TableCell>
                                <TableCell align="left">{error.field}</TableCell>                                
                                <TableCell align="left">{error.fieldValue}</TableCell>                                
                              </TableRow>
                            ))
                            )) : ''}
                        </TableBody>
                      </Table>
                    </TableContainer>
                    <br></br>
                  </div>
                </UncontrolledCollapse>
</Container>
</div>
          <DefaultFooter />
        </div>
    )
}};

const mapStateToProps = (response) => ({response});

export default connect(mapStateToProps)(UploadFile);